import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { isLocationAvailableWithAffirm } from '../../../../../../api/Utils/affirmUtils';
import { isValidPrice } from '../../../../../../utilities/cmpPackagesUtils';
import { SupAmount } from '../../../../../ui-kit';
import theme, { fontSizes } from '../../../../../ui-kit/themes/theme';
import { handleTotalWithTaxes } from '../../../../../utilities/utils';
import { SummaryContent } from '../../../Content';
import * as COPY from '../../utilities/copy';
import { AffirmLink } from './AffirmLink';

const propTypes = {
  /** Flag to indicate if exist packages for the reservation */
  hasSelectedPackages: PropTypes.bool,

  /** Total for the reservation */
  summaryTotal: PropTypes.number.isRequired,

  /** loyalty points balance */
  pointAmount: PropTypes.number,

  /** loyalty boolean to show or not the value */
  loyaltyOptIn: PropTypes.bool
};

export const Totals = ({
  hasSelectedPackages,
  summaryTotal,
  pointAmount,
  loyaltyOptIn,
  showLoyalty,
  userOffers,
  activeOffers,
  suiteTotal,
  taxesAndFees,
  roomAdjustmentTax,
  isUserAuthenticated,
  currentSelectedPackages,
  setExcedent,
  resortLocation,
  shouldSavePoints
}) => {
  const [refreshAffirm, setRefreshAffirm] = useState(new Date().getTime());

  const handleSummaryTotal = isUserAuthenticated
    ? handleTotalWithTaxes(
        userOffers,
        activeOffers,
        showLoyalty,
        loyaltyOptIn,
        shouldSavePoints ? 0 : pointAmount,
        suiteTotal,
        taxesAndFees,
        roomAdjustmentTax,
        currentSelectedPackages,
        setExcedent
      )
    : summaryTotal?.toFixed(2);

  useEffect(() => {
    setRefreshAffirm(new Date().getTime());
  }, [hasSelectedPackages, summaryTotal, handleSummaryTotal]);

  return isValidPrice(summaryTotal) ? (
    <>
      <SummaryContent.Divider />
      <SummaryContent.Item
        fontSize={['18px', null, null, '18px']}
        fontWeight={theme.fontWeights.bold}
        role="complementary"
        aria-label="Total Price"
        lineHeight={'22px'}>
        <SummaryContent.Description data-testid="suite-total" fontSize={fontSizes[7]}>
          {COPY.TOTAL}
        </SummaryContent.Description>
        <SummaryContent.SubtotalAmount fontWeight="bold">
          <SupAmount fontSize={7} textToUse={`$${handleSummaryTotal}`} avoidFormat={true} />
        </SummaryContent.SubtotalAmount>
      </SummaryContent.Item>

      {isLocationAvailableWithAffirm(resortLocation) ? (
        <SummaryContent.Item mb={`${theme.space[7]}px`}>
          <AffirmLink
            refreshAffirm={Boolean(refreshAffirm)}
            summaryTotal={!isNaN(Number(handleSummaryTotal)) ? Number(handleSummaryTotal) : 0}
            resortLocation={resortLocation}
          />
        </SummaryContent.Item>
      ) : null}
    </>
  ) : null;
};

Totals.propTypes = propTypes;

Totals.defaultProps = {
  hasSelectedPackages: false,
  pointAmount: 0,
  loyaltyOptIn: false
};
